import GiftImageProvider from './hooks/useGiftImage';

import { GiftImageProps } from './@types/GiftImageProps';

const GiftImage = (props: GiftImageProps) => {
	const renderStyle = () => {
		return {
			minWidth: `${props.minWidth ?? 125}px`,
			maxWidth: `${props.maxWidth ?? 125}px`,
			minHeight: `${props.minHeight ?? 125}px`,
			maxHeight: `${props.maxHeight ?? 125}px`,
		};
	};

	const src = props.mzGiftImage ?? 'https://i.imgur.com/EFLGTEP.png';

	return (
		<GiftImageProvider {...props}>
			<img
				data-selection={props?.componentId}
				src={`${src}`}
				alt=""
				className="vtex-product-gifts-0-x-imageElement imageElement vtex-store-components-3-x-imageElement"
				style={renderStyle()}
			/>
		</GiftImageProvider>
	);
};

export default GiftImage;
